<template>
  <div class="card flex-row flex-wrap" @click="watchVideo(videoLecture.id)">
    <div class="card-header border-0">
      <img v-if="videoPicture" :src="videoPicture" alt="publisher-profile">
      <div v-if="isCurrentCard" class="card-state-text">{{ $t('common.during_learning') }}</div>
      <div class="card-img-info">{{ videoDuration }}</div>
    </div>
    <div class="card-block px-2">
      <div class="card-title">{{ videoTitle }}</div>
      <div class="card-text-1">{{ videoPublisher }}</div>
      <div class="card-text-2">{{ videoGrade }} {{ videoSubjectName }}</div>
      <div class="card-text-3">{{ $t('common.view_count') }} {{ getFormatCount(videoViewsCount) }}</div>
      <div class="card-text-4">{{ $t('common.like_up') }} {{ getFormatCount(videoLikesCount) }}</div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import moment from 'moment/src/moment';
  import { find, maxBy } from 'lodash';

  import numbers from '@/mixins/numbers';
  import labels from '@/mixins/labels';

  export default {
    name: 'left-image-card',

    mixins: [
      labels,
      numbers,
    ],

    props: {
      videoLecture: {
        type: Object,
      },
      isCourseCard: {
        type: Boolean,
        default: false,
      },
      courseId: {
        type: Number,
      },

      isCurrentCard: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        videoBackgroundSize: {
          width: 295,
          height: 166,
        },
      };
    },

    computed: {
      ...mapGetters({
        subjectMap: 'getSubjectMap',
        gradeMap: 'getGradeMap',
      }),

      videoTitle() {
        return this.videoLecture.title;
      },

      videoPublisher() {
        return this.videoLecture.owner.name;
      },

      filterSubject() {
        return find(this.subjectMap, { id: this.videoLecture.subject_id }) || {};
      },

      videoSubjectName() {
        return this.filterSubject.name;
      },

      video() {
        return this.videoLecture && this.videoLecture.video;
      },

      filterVideoPicture() {
        const videoPicture = find(this.video.pictures, { width: this.videoBackgroundSize.width });
        if (!videoPicture) {
          return maxBy(this.video.pictures, item => item.width);
        }

        return videoPicture;
      },

      videoGrade() {
        return this.getTranslatedName(this.gradeMap[this.videoLecture.grade_id]);
      },

      videoPicture() {
        if (!this.filterVideoPicture) {
          return false;
        }

        return this.filterVideoPicture.link;
      },

      videoLikesCount() {
        return this.videoLecture.like_count;
      },

      videoViewsCount() {
        return this.videoLecture.view_count;
      },

      videoDuration() {
        return moment.utc(this.video && this.video.duration * 1000).format('mm:ss');
      },
    },

    methods: {
      watchVideo(videoId) {
        if (this.isCourseCard) {
          return this.$router.push(`/video/${videoId}?course_id=${this.courseId}`);
        }

        return this.$router.push(`/video/${videoId}`);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .card {
    border: none;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
    background-color: #ffffff;
    cursor: pointer;

    .card-state-icon {
      position: absolute;
      right: 0px;
      border-right: 12px solid transparent;
      border-bottom: 12px solid;
      background-color: rgba(0, 0, 0, 0.1);
      color: #00C896;
    }

    .card-header {
      background-color: #ffffff;
      width: 50%;
      padding: 14px;
      position: relative;
      height: 168px;

      img {
        width: 100%;
        height: 140px;
        object-fit: cover;
      }

      .card-state-text {
        position: absolute;
        left: 0px;
        width: 48px;
        height: 20px;
        margin: 14px;
        top: 0px;
        color: #ffffff;
        background-color: #00c896;
        z-index: 4;
        text-align: center;
      }

      .card-img-info {
        position: absolute;
        bottom: 0;
        right: 0;
        color: #ffffff;
        background: #000000;
        font-size: 12px;
        margin: 24px;
        padding: 1px 4px;
        border-radius: 4px;
      }
    }

    .card-block {
      font-size: 14px;
      padding: 14px;
      width: 50%;

      .card-title {
        font-size: 16px;
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-inline-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        max-height: 40px;
        word-break: break-all;
        white-space: normal;
      }

      .card-text {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.38);
        padding: 0 0 4px 0; 
      }
    }
  }

</style>


// WEBPACK FOOTER //
// LeftImageCard.vue?24c9b50d